import type { AdapterMeta } from "@repo/adapter-core";

export const KAY_BURTON_BAYSIDE_META: AdapterMeta = {
  slug: "kay-burton-bayside",
  name: "Kay & Burton Bayside",
  baseUrl: "https://www.kayburton.com.au",
  description: "Prestige agency focused on Melbourne's bayside suburbs.",
  supportedStates: ["VIC"],
  urlPattern: /kayburton\.com\.au\/sale\/vic\/[a-z0-9-/]+\/\d+$/i,
  sourceType: "agency",
};
